const init = () => {


    if (document.querySelector('.ways')) {
        document.querySelector('.ways').addEventListener('mouseover', (ev) => {
            if (ev.target.closest('.ways__item')) {
                const num = ev.target.closest('.ways__item').getAttribute('data-num');

                document.querySelector(`.prices__item[data-num = '${num}']`).style.opacity = 1
                document.querySelector(`.prices__item[data-num = '${num}']`).style.transform = `translateX(0px)`
                document.querySelector(`.prices__item[data-num = '${num}']`).style.transition = `all 0.4s ease`

                document.querySelector(`.ways__item[data-num = '${num}']`).addEventListener('mouseout', event => {
                    document.querySelector(`.prices__item[data-num = '${num}']`).style.transform = `translateX(0px)`
                    document.querySelector(`.prices__item[data-num = '${num}']`).style.opacity = 0
                    document.querySelector(`.prices__item[data-num = '${num}']`).style.transition = `all 0s ease`

                })
            }
        })
    }


    if (document.querySelector('.swiper1')) {


        const screenWidth = window.innerWidth;

        if (screenWidth >= 768) {
            const swiper = new Swiper('.swiper1', {
                // Optional parameters
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 20,
                loop: true,

                breakpoints: {
                    // When window width is >= 768px
                    1400: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                        spaceBetween: 12,
                    },

                },
                // Navigation arrows
                navigation: {
                    nextEl: '.swiper1-button-next',
                    prevEl: '.swiper1-button-prev',
                },
                pagination: {
                    el: '.swiper1-pagination',
                },

            });

        }

    }


    let modalVideo = {
        'review-semchyk': '/static/main-page_v2/vid/reviews/semchyk.mp4',
        'review-sergacheva': '/static/main-page_v2/vid/reviews/sergacheva.mp4',
        'review-volkova': '/static/main-page_v2/vid/reviews/volkova.mp4',
    };

    if (document.querySelector('.video-reviews')) {
        // Функция закрытия модального окна
        function closeModal() {
            const modalWrap = document.querySelector('.iframe-video-wrap');
            if (modalWrap) {
                document.querySelector('.app__content').removeChild(modalWrap);
                document.body.style.overflow = '';
            }
        }

        // Функция открытия видео
        function openVideo(videoId) {
            console.log(1)
            const videoUrl = modalVideo[videoId];

            if (!videoUrl) return; // Если видео не найдено, ничего не делаем

            const iframe = document.createElement('div');

            // Определяем тип видео по расширению
            const videoType = videoUrl.endsWith('.mov') ? 'video/quicktime' : 'video/mp4';

            iframe.innerHTML = `
            <video 
                class="iframe-video" 
                width="250" 
                height="475" 
                controls
                autoplay="autoplay">
                <source src="${videoUrl}" type="${videoType}">
                Ваш браузер не поддерживает видео.
            </video>
            <button class="iframe-close">&times;</button>
            <div class="overlay"></div>
        `;

            iframe.classList.add('iframe-video-wrap');
            document.querySelector('.app__content').appendChild(iframe);
            document.body.style.overflow = 'hidden';

            // Добавляем обработчики закрытия
            const overlay = iframe.querySelector('.overlay');
            const closeBtn = iframe.querySelector('.iframe-close');

            if (overlay) {
                overlay.addEventListener('click', closeModal);
            }

            if (closeBtn) {
                closeBtn.addEventListener('click', closeModal);
            }

            // Автоматически запускаем видео
            const videoElement = iframe.querySelector('video');
            if (videoElement) {
                videoElement.play().catch(error => {
                    console.log('Autoplay prevented:', error);
                });
            }
        }

        // Обработчик клика на весь блок video-reviews
        document.querySelector('.video-reviews').addEventListener('click', function(evt) {
            // Ищем ближайший элемент swiper-slide (включая сам элемент, если кликнули на него)
            const slide = evt.target.closest('.swiper-slide');

            if (slide) {
                const videoId = slide.getAttribute('id');

                // Проверяем, есть ли у слайда id и существует ли такое видео в modalVideo
                if (videoId && modalVideo[videoId]) {
                    openVideo(videoId);
                }
            }
        });
    }


    if (document.querySelector('.articles-swiper')) {
        const swiper0 = new Swiper('.articles-swiper', {
            // Optional parameters
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 20,


            breakpoints: {
                // When window width is >= 768px
                768: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 12,
                },

                1400: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 12,
                },

            },
            // Navigation arrows
            navigation: {
                nextEl: '.swiper-articles-button-next',
                prevEl: '.swiper-articles-button-prev',
            },
            pagination: {
                el: '.swiper-articles-pagination',
            },


        });
    }

    if (document.querySelector('.swiper-video-reviews')) {
        const swiper = new Swiper('.swiper-video-reviews', {
            // Optional parameters
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 20,


            breakpoints: {
                // When window width is >= 768px
                768: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 12,
                },

                1400: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 12,
                },

            },
            // Navigation arrows
            navigation: {
                nextEl: '.swiper-video-reviews-button-next',
                prevEl: '.swiper-video-reviews-button-prev',
            },
            pagination: {
                el: '.swiper-video-reviews-pagination',
            },


        });
    }

    if (document.querySelector('.swiper2')) {
        const swiper2 = new Swiper('.swiper2', {
            // Optional parameters
            slidesPerView: 1,
            loop: true,
            centeredSlides: true,

            // If we need pagination
            pagination: {
                el: '.swiper2-pagination',
            },

            // Navigation arrows
            navigation: {
                nextEl: '.swiper2-button-next',
                prevEl: '.swiper2-button-prev',
            },
            pagination: {
                el: '.swiper-reviews-pagination',
            },
        });

    }

    if (document.querySelector('.swiper3')) {
        const width = window.innerWidth

            const swiper3 = new Swiper('.swiper3', {
                // Optional parameters
                slidesPerView: 1,
                // slidesPerGroup: 3,
                // loop: true,
                spaceBetween: 10,
                breakpoints: {


                    // When window width is >= 768px
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 12,
                        slidesPerGroup: 2,
                    },

                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 12,
                        slidesPerGroup: 3,
                    },

                    1400: {
                        slidesPerView: 4,
                        spaceBetween: 12,
                        slidesPerGroup: 4,
                        grid: {
                            rows: 2, // Number of rows
                            fill: 'row', // or 'column' depending on desired slide order
                        },
                    },

                },
                // If we need pagination
                pagination: {
                    el: '.swiper3-pagination',
                },

                // Navigation arrows
                navigation: {
                    nextEl: '.swiper3-button-next',
                    prevEl: '.swiper3-button-prev',
                },

            });


        if (document.querySelector('.swiper4')) {
            if (width > 767 && width < 1024) {
                const swiper4 = new Swiper('.swiper4', {
                    // Optional parameters
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    // loop: true,
                    spaceBetween: 10,
                    breakpoints: {


                        // When window width is >= 768px
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 12,
                        },
                    },
                    // If we need pagination
                    pagination: {
                        el: '.swiper4-pagination',
                    },

                    // Navigation arrows
                    navigation: {
                        nextEl: '.swiper4-button-next',
                        prevEl: '.swiper4-button-prev',
                    },

                });

            }
        }

    }

    if (document.querySelector('.courses-catalog')) {
        const specsFilter = document.getElementById('specsFilter');
        const coursesContainer = document.getElementById('coursesContainer');
        const noCoursesElement = document.getElementById('noCourses');

        if (!specsFilter || !coursesContainer || !noCoursesElement) {
            console.log('Элементы для фильтрации курсов не найдены на странице');
            return;
        }

        // Данные направлений
        const specs = {
            'pop': 'Популярные',
            'all': 'Все курсы',
            'marketing': 'Маркетинг',
            'ai': 'Нейросети',
            'kom': 'Коммуникации',
            'advertising': 'Реклама',
            'design': 'Брендинг',


            'free': 'Бесплатные'
        };

        // Данные курсов
        const courses = [

            {

                'title': 'Онлайн-работа <br>на Ozon',
                'speaker': [
                    {
                        'name': 'Мария Говоркова',
                        'pic': '/static/landings_v2/ozon/img/govorkova.png',
                        'add': ''
                    },
                ],
                'description': 'Видеокурс для новичков о&nbsp;работе на&nbsp;Ozon.&nbsp;23&nbsp;урока, до&nbsp;6&nbsp;часов. Регистрация, юнит-экономика, карточка, реклама.<br>   Стартуйте удалённо.',
                'summory': 'Освойте востребованную профессию ассистента маркетплейса &nbsp;начните зарабатывать удалённо на&nbsp;Ozon. <br><br> На&nbsp;курсе вы&nbsp;научитесь регистрировать кабинет продавца, выбирать прибыльные товары, оформлять карточки и&nbsp;поставки, запускать рекламу и&nbsp;анализировать продажи. <br><br> Разберётесь, как устроена работа внутри маркетплейса и&nbsp;как эффективно взаимодействовать с&nbsp;командой. <br><br> Курс подойдёт новичкам без опыта, мамам в&nbsp;декрете, студентам и&nbsp;всем, кто ищет стабильный удалённый доход. ',
                'features': [],
                'spec':  ['marketing'],
                'pop': 'true',
                'free': '',
                'link': '/courses/marketing/56-online-rabota-na-ozon',
            },

            {

                'title': 'Карточки для маркетплейсов: дизайн и&nbsp;нейросети',
                'speaker': [
                    {
                        'name': 'Ярослав Твердов',
                        'pic': '/static/landings_v2/cards/img/tverdov.png',
                        'add': ''
                    },
                ],
                'description': 'Курс по дизайну карточек с ИИ: создавайте визуал, который продаёт',
                'summory': 'Освойте востребованный навык создания продающих карточек для маркетплейсов и прокачайте дизайн с помощью нейросетей. <br><br> На курсе вы научитесь управлять вниманием покупателя, усиливать визуал и повышать конверсию. <br><br>Разберетесь, как создавать карточки под задачи бренда и работать быстрее с ИИ.  <br><br>Курс подойдёт дизайнерам и специалистам e-commerce, которые хотят выйти на новый уровень и увеличить свой доход',
                'features': [],
                'spec':  ['ai', 'marketing', 'design'],
                'pop': '',
                'free': '',
                'link': '/courses/ai/53-aimarketplace',
            },
            {
                'title': 'Личный бренд эксперта: SMM-стратегия',
                'speaker': [
                    {
                        'name': 'Никита Прохоров',
                        'pic': '/static/landings_v2/prohorov/img/prohorov.png',
                        'add': ''
                    },
                ],
                'description': 'Видеокурс «Личный бренд эксперта: SMM-стратегия»: постройте систему продвижения в соцсетях за 6 уроков. Контент-план, сторителлинг, работа с негативом, нейросети. Курс Никиты Прохорова (Sidorin Lab).',
                'summory': 'Практическая программа, где вы выстроите системное\n' +
                    'продвижение в соцсетях: от позиционирования и упаковки\n' +
                    'профилей до контент-плана и работы с репутацией. <br><br> Курс\n' +
                    'читает сооснователь Sidorin Lab, одного из крупнейших в\n' +
                    'России агентств по управлению репутацией. <br><br> За 6 уроков вы\n' +
                    'создадите личную стратегию, освоите сторителлинг, научитесь\n' +
                    'управлять негативом и внедрите нейросети для генерации\n' +
                    'контента',
                'features': [],
                'spec': 'kom',
                'pop': 'true',
                'free': '',
                'link': '/courses/communications/52-smm-strategy',
            },
            {

                'title': 'AEO/GEO: как сделать контент видимым для ИИ и попасть в AI-ответы',
                'speaker': [
                    {
                        'name': 'Михаил Евдокимов',
                        'pic': '/static/main-page_v2/img/speakers/evdokimov.png',
                        'add': ''
                    },
                ],
                'description': 'Начните адаптировать свои статьи так, чтобы Google AI, Яндекс Алиса и ChatGPT выбирали ваш контент как источник\n',
                'summory': '' +
                    '                                Практический курс о том, как перестроить контент под новую реальность поиска, где Google, Яндекс, ChatGPT и другие ИИ дают готовые ответы прямо в выдаче. Вы поймёте, почему SEO уже не работает как раньше, что такое AI SEO, AEO и GEO, и как сделать контент видимым для моделей — даже если ваш сайт не в топ-10.\n' +
                    '\n' +
                    '                                <br><br>Вы разберётесь, как ИИ «читает» страницы, почему он берёт только короткие структурированные фрагменты, как работают AI Overviews и блок Алиса, и что нужно сделать, чтобы ваш сайт стал источником для цитирования. Научитесь писать «короткие записки», которые ИИ легко вставляет в ответы, задавать правильные формулировки, использовать разметку FAQ и HowTo и закрывать реальные вопросы вашей аудитории.\n' +
                    '                           ',
                'features': [],
                'spec': ['ai', 'marketing'],
                'pop': 'true',
                'free': '',
                'link': '/courses/ai/50-geo-aeo',
            },



            {

                'title': 'Контент-маркетинг в&nbsp;IT: от&nbsp;стратегии к&nbsp;продажам',
                'speaker': [
                    {
                        'name': 'Диана Акчурина',
                        'pic': '/static/main-page_v2/img/speakers/akchurina.png',
                        'add': ''
                    },
                ],
                'description': 'Как выстроить контент-стратегию в IT: от CJM и аналитики до дистрибуции, сторителлинга и роста продаж через системный контент-маркетинг',
                'summory': '                                Практический курс о том, как создавать контент, который работает на узнаваемость, доверие и движение клиента по воронке.\n' +
                    '                                <br><br>Вы разберётесь, как анализировать аудиторию, выстраивать ToFu–MoFu–BoFu, находить точки контакта, формировать экспертный контент и использовать правильные форматы в технологической сфере.\n' +
                    '                                <br><br>Научитесь планировать дистрибуцию, работать с аналитикой, извлекать экспертизу из команды и выстраивать контент-процессы, которые поддерживают рост продукта и компании. Внутри — разборы кейсов tech-брендов и практические задания для применения в работе\n' +
                    '                             ',
                'features': [],
                'spec': 'kom',
                'pop': 'true',
                'free': '',
                'link': '/courses/communications/46-it-pr',
            },

            {

                'title': 'Наука <br>побеждать',
                'speaker': [
                    {
                        'name': 'Владилен Ситников',
                        'pic': '/static/main-page_v2/img/speakers/sitnikov.png',
                        'add': ''
                    },
                ],
                'description': 'Как превратить идею в заявку, которую прочитают, заметят и оценят по достоинству на престижных фестивалях креатива и маркетинговых коммуникаций\n',
                'summory': '                               Научитесь делать кейсы, которые выигрывают. Путь от инсайта до заявки, которая будет выигрывать фестивали.\n' +
                    '                                <br><br>\n' +
                    '                                Курс «Наука побеждать» создан для тех, кто хочет превратить классные идеи в реальные фестивальные победы.\n' +
                    '                                <br>\n' +
                    '                                <br>\n' +
                    '                                Вы разберете критерии жюри, научитесь формулировать сильные инсайты, структурировать кейсы под требования фестиваля и подавать их так, чтобы вас заметили.\n' +
                    '                                <br>\n' +
                    '                                <br>\n' +
                    '                                Поймете, как работают судьи и почему побеждают не только яркие, но и грамотно оформленные проекты.\n' +
                    '                            ',
                'features': [],
                'spec': ['marketing', 'kom', 'advertising'],
                'pop': 'true',
                'free': '',
                'link': '/courses/marketing/38-nauka-sitnikov',
            },

            {
                'title': 'Нейросети От визуала до&nbsp;автоматизации',
                'speaker': [
                    {
                        'name': 'Денис Родин',
                        'pic': '/static/main-page_v2/img/speakers/rodin.png',
                        'add': ''
                    },

                ],
                'description': 'От простых запросов до симбиоза нейросетей: сможете решать любые рабочие задачи с помощью AI и делать то, что раньше казалось невозможным\n',
                'summory': '                         Полная система работы с AI: от текста до видео, от визуала до монетизации\n' +
                    '                                <br><br>\n' +
                    '                                Практический курс, где вы не просто изучите нейросети —\n' +
                    '                                а соберете из них рабочую экосистему под свои задачи.\n' +
                    '                                Научитесь писать с ChatGPT, делать визуалы в Midjourney, создавать видео через Kling и Veo 3, озвучивать голосом ElevenLabs и автоматизировать задачи с помощью AI-инструментов.\n' +
                    '                                <br>\<br>\n' +
                    '                                Вы получите четкую методику, как работать в связке с AI, а не по шаблонам.\n' +
                    '                            ',
                'features': [],
                'spec': 'ai',
                'pop': 'true',
                'free': '',
                'link': '/courses/ai/36-ai-chatgpt-neuroseti-sostav',
            },

            {
                'title': 'Нетворкинг <br> простыми <br>словами',
                'speaker': [
                    {
                        'name': 'Ника Лукина',
                        'pic': '/static/main-page_v2/img/speakers/lukina.png',
                        'add': ''
                    },

                ],
                'description': 'Как выстроить устойчивую сеть профессиональных связей с опорой на стратегию, EQ и PRM-подход\n',
                'summory': '                                Практический курс о&nbsp;том, как выстраивать эффективные связи, управлять впечатлением, работать с&nbsp;целевой аудиторией, прокачивать эмоциональный интеллект и&nbsp;преодолевать стресс в&nbsp;деловом общении.\n' +
                    '                              <br><br>  Вы научитесь формулировать цели, создавать стратегии нетворкинга, укреплять доверие и&nbsp;строить личный бренд на&nbsp;основе ценностей и&nbsp;репутации.\n' +
                    '                              <br><br>  Курс включает 7&nbsp;видеоуроков, упражнения и&nbsp;техники, которые помогут создавать осознанные и&nbsp;сильные профессиональные связи, развивать комьюнити и&nbsp;уверенно общаться в&nbsp;любых ситуациях.\n' +
                    '                           ',
                'features': [],
                'spec': 'kom',
                'pop': '',
                'free': '',
                'link': '/courses/communications/34-networking',
            },

            {
                'title': 'Трансформация бизнес-целей в&nbsp;медийные KPI',
                'speaker': [
                    {
                        'name': 'Светлана Авилкина',
                        'pic': '/static/main-page_v2/img/speakers/avilkina.png',
                        'add': ''
                    },

                ],
                'description': 'от SMART-целей до ROI: как связать бизнес, маркетинг и медиа в единую экосистему\n',
                'summory':'                                Специальный практический курс от Starlink Group – экспертов в области построения коммуникационных стратегических решениий и медиапланировании.\n' +
                    '                      <br><br>          Вы научитесь связывать маркетинг с продажами через правильную постановку медийных задач. Разберетесь в методологии SMART, SWOT-анализе и других необходимых инструментах.\n' +
                    '                         <br><br>       Курс включает в себя 7 видеоуроков с объемными практическими заданиями, которые вы сможете разобрать совместно с экспертом.\n' +
                    '                            ',
                'features': [],
                'spec': ['marketing', 'advertising'],
                'pop': '',
                'free': '',
                'link': '/courses/marketing/33-starlink',
            },

            {
                'title': 'PR для&nbsp;рекламных агентств',
                'speaker': [
                    {
                        'name': 'Ульяна Громова',
                        'pic': '/static/main-page_v2/img/speakers/gromova.png',
                        'add-class': ''
                    },

                ],
                'description': 'Прокачайте репутацию агентства — и станьте заметными для клиентов, СМИ и индустрии\n',
                'summory': '' +
                    '                                Видеокурс для специалистов, которые занимаются продвижением рекламных агентств. Эксперт расскажет о том, как эффективно работать с рейтингами, как разрабатывать креативные PR-поводы для рекламного рынка. Затронет аспекты взаимодействия с отраслевыми медиа и разрберет основные ошибки, которые допускает агентство. <br><br> В конце уроков вас ждем практическое задание, которое вы сможете отправить на проверку эксперту и получить обратную связь.\n',
                'features': [],
                'spec': 'kom',
                'pop': '',
                'free': '',
                'link': '/courses/communications/32-b2bpr',
            },

            {
                'title': 'Управление репутацией в&nbsp;интернете',
                'speaker': [
                    {
                        'name': 'Валентина Сидоренко',
                        'pic': '/static/main-page_v2/img/speakers/sidorenko.png',
                        'add': ''
                    },
                    {
                        'name': 'Никита Сушков',
                        'pic': '/static/main-page_v2/img/speakers/sushkov.png',
                        'add': ''
                    },

                ],
                'description': 'Практический курс по Online reputation management\n',
                'summory': '                                Анализ и контроль репутации бренда в поисковой выдаче и социальных сетях. Удаление негативных отзывов и минимизация их влияния на имидж.\n' +
                    '                             <br><br>  Эффективное управление отзывами и геосервисами. Работа с негативными комменатриями и предотвращение репутационных кризисов.\n' +
                    '                            ',
                'features': [],
                'spec': 'kom',
                'pop': '',
                'free': '',
                'link': '/courses/business/30-upravlenie-reputaciey',
            },

            {
                'title': 'Бесплатный курс Теlegram',
                'speaker': [
                    {
                        'name': 'Никита Петенко, Григор Чтчян',
                        'smaller': 'smaller',
                        'pic': '/static/main-page_v2/img/speakers/petenko-chtchan.png',
                        'add': 'more'
                    },

                ],
                'description': 'Создание, управление и продвижение канала с&nbsp;нуля',
                'summory': '' +
                    '                                На большом бесплатном курсе вы поставите освоите эффективные методы продвижения, узнаете, какие инструменты реально работают, сколько они стоят и как именно помогут вам продвигать канал или бизнес\n',
                'features': [],
                'spec': 'kom',
                'pop': '',
                'free': 'true',
                'link': '/courses/communications/27-telegram-producer',
            },

/*            {
                'title': 'Нейросети в&nbsp;маркетинговых и&nbsp;digital-стратегиях',
                'speaker': [
                    {
                        'name': 'Антон Вдовиченко',
                        'pic': '/static/main-page_v2/img/speakers/vdovichenko.png',
                        'add': ''
                    },

                ],
                'description': 'Четыре авторских вебинара Антона Вдовчиенко',
                'summory': '                                Эксперт покажет, как использовать искусственный интеллект для решения бизнес-задач и&nbsp;объяснит на&nbsp;реальных кейсах, как применять AI-технологии в&nbsp;маркетинге и&nbsp;создании контента.\n',
                'features': [],
                'spec': 'ai',
                'pop': '',
                'free': 'true',
                'link': '/ai-webinar',
            },*/

            {
                'title': 'Формула сильного бренда',
                'speaker': [
                    {
                        'name': 'Игорь Померанцев',
                        'pic': '/static/main-page_v2/img/speakers/pomerantsev.png',
                        'add': ''
                    },

                ],
                'description': 'Как создать бренд, который будет расти вместе с продуктом и привлекать свою аудиторию\n',
                'summory': 'Профессиональное выступление Игоря Померанцева&nbsp;&mdash; настоящее руководство по&nbsp;разработке сильного бренда, который сможет выделиться на&nbsp;фоне конкурентов благодаря необычному подходу.\n' +
                    '                                    <br><br>Эксперт на&nbsp;конкретных примерах покажет, как можно сегментировать целевую аудиторию, и&nbsp;применять это знание при создании бренда для своих продуктов.\n' +
                    '                            ',
                'features': [],
                'spec': 'marketing',
                'pop': '',
                'free': '',
                'link': '/courses/marketing/22-formula-silnogo-brenda',
            },

            {
                'title': 'Как работает медиааудит',
                'speaker': [
                    {
                        'name': 'Павел Питилимов',
                        'pic': '/static/main-page_v2/img/speakers/pitilimov.png',
                        'add': ''
                    },

                ],
                'description': 'Как оценивать эффективность рекламных кампаний, проверять подрядчиков и выбирать лучшие тендерные предложения\n',
                'summory': 'Медиааудит&nbsp;&mdash; мощный инструмент, который помогает рекламодателям спланировать бюджеты наиболее оптимальным образом, убедиться в&nbsp;эффективности рекламной кампании и&nbsp;проверить подрядчиков, которые привлечены к&nbsp;работе. О&nbsp;том, как устроен медиааудит и&nbsp;как применять его на&nbsp;практике, объяснит экспертный курс от&nbsp;руководителя одной из&nbsp;девяти российских медиааудиторских компаний.',
                'features': [],
                'spec': 'advertising',
                'pop': '',
                'free': '',
                'link': '/courses/reklama/15-mediaaudit',
            },

            {
                'title': 'Разработка бренда, айдентики и&nbsp;наименования',
                'speaker': [
                    {
                        'name': 'Илья Лазученков, Илья Редько, Игорь Померанцев, Валерия Репина, Алексей Ашуркин',
                        'smaller': 'smaller',
                        'pic': '',
                        'add': 'd-none'
                    },

                ],
                'description': 'Пошаговая система от ведущих экспертов:\n' +
                    'от формулы сильного бренда до цифровой айдентики.',
                'summory': 'Интенсив разработан ведущими специалистами в&nbsp;области построения бренда. <br><br>Эксперты остановятся на основных этапах разработки бренда, его визуальных составляющих и выбора наименования для продукта.',
                'features': [],
                'spec': 'design',
                'pop': '',
                'free': '',
                'link': '/courses/marketing/5-razrabotka-ajdentiki-i-naimenovaniya',
            },

            {
                'title': 'Жесткий B2B —  B2B-трафик и&nbsp;лиды, без физиков',
                'speaker': [
                    {
                        'name': 'Анатолий Русанов',
                        'pic': '/static/main-page_v2/img/speakers/rusanov.png',
                        'add': ''
                    },

                ],
                'description': 'Как получать B2B-трафик и целевые B2B-лиды, не собирая физиков\n',
                'summory': 'Мини-курс из пяти уроков, в которых эксперт поделится своими алгоритмами и кейсами по привлечению В2В-лидов, поделится инструментами, которые позволят фильтровать трафик, пользоваться таргетингом для В2В-сегмента и получать более качественные лиды, покажет, как выбирать канали для повышения трафика с учетом специфики В2В сегмента.',
                'features': [],
                'spec': 'marketing',
                'pop': '',
                'free': 'true',
                'link': '/courses/marketing/19-rusanov-b2b',
            },


            {
                'title': 'Маркировка рекламы',
                'speaker': [
                    {
                        'name': 'Артем Попов,<br> Анжелла Козаченко',
                        'smaller': 'smaller',
                        'pic': '/static/main-page_v2/img/speakers/kozachenko-popov.png',
                        'add': 'more'
                    },

                ],
                'description': 'Как разобраться в правилах и не получить штраф\n',
                'summory': 'Экспертные материалы по&nbsp;маркировке интернет-рекламы, объединенные в&nbsp;бесплатный видеокурс из&nbsp;четырех уроков. <br><br>Разберитесь во&nbsp;всех тонкостях нового законодательства и&nbsp;освойте нюансы пометок в&nbsp;SMM, медийной рекламе и&nbsp;публикациях в&nbsp;СМИ',
                'features': [],
                'spec': ['kom', 'advertising'],
                'pop': '',
                'free': 'true',
                'link': '/courses/communications/8-markirovka-reklamy',
            },

            {
                'title': 'Продвижение бренда через стримеров',
                'speaker': [
                    {
                        'name': 'Диана Симон',
                        'pic': '/static/main-page_v2/img/speakers/simon.png',
                        'add': ''
                    },

                ],
                'description': 'Как использовать стриминговые платформы Twitch, Trovo и аналоги для рекламы бренда и монетизации контента\n',
                'summory': 'Реклама на&nbsp;стриминговых платформах&nbsp;&mdash; один из&nbsp;главных трендов нового времени. <br><br> Диана Симон из&nbsp;агентства Gamers Club Agency познакомит вас с&nbsp;рекламным форматами Twitch и&nbsp;аналогичных сервисов и&nbsp;расскажет, когда и&nbsp;как бренд должен начинать работать со&nbsp;стримерами',
                'features': [],
                'spec': 'marketing',
                'pop': '',
                'free': 'true',
                'link': '/courses/marketing/14-prodvizhenie-brenda-cherez-strimerov',
            },

            {
                'title': 'Айдентика как инструмент',
                'speaker': [
                    {
                        'name': 'Илья Лазученков',
                        'pic': '/static/main-page_v2/img/speakers/lazuchenkov.png',
                        'add': ''
                    },

                ],
                'description': 'Как визуальный стиль помогает бизнесу расти и выделяться на рынке',
                'summory': 'Видеоурок систематизирует ваши знания в&nbsp;сфере построения бренда и&nbsp;его визуальных атрибутов. <br><br> Поможет получить представление о&nbsp;современных дизайн-концепциях и&nbsp;подходах к&nbsp;созданию айдентики. <br><br> Вы&nbsp;узнаете, как строится работа над визуальным образом компании',
                'features': [],
                'spec': 'design',
                'pop': '',
                'free': '',
                'link': '/courses/design/1-ajdentika-kak-instrument',
            },

            {
                'title': 'Нейминг: разработка наименования',
                'speaker': [
                    {
                        'name': 'Валерия Репина',
                        'pic': '/static/main-page_v2/img/speakers/repina.png',
                        'add': ''
                    },

                ],
                'description': 'Как придумать или выбрать название, которое выделит продукт и пройдет регистрацию\n',
                'summory': 'Видеоурок Валерии Репиной, генерального директора агентства Repina. Branding. <br><br>Эксперт научит разрабатывать наименование для нового продукта, познакомит с&nbsp;основными принципами нейминга и&nbsp;объяснит, как обойти трудности и&nbsp;острые углы в&nbsp;процессе запуска',
                'features': [],
                'spec': ['design', 'marketing'],
                'pop': '',
                'free': '',
                'link': '/courses/marketing/6-razrabotka-naimenovaniya',
            },

            {
                'title': 'Бренд в&nbsp;digital среде',
                'speaker': [
                    {
                        'name': 'Илья Редько, Алексей Ашуркин',
                        'smaller': 'smaller',
                        'pic': '/static/main-page_v2/img/speakers/redko-ashurkin.png',
                        'add': 'more'
                    },

                ],
                'description': 'Узнаете, как работает цифровая айдентика и какой подход подойдет именно вашему бренду\n',
                'summory': 'Видеоурок с&nbsp;кейсами по&nbsp;digital айдентике, разработанный агентством Only. <br><br> Эксперты помогут разобраться в&nbsp;подходах адаптации айдентики к&nbsp;цифровой среде и&nbsp;дадут представление о&nbsp;современных дизайн-концепциях digital айдентики',
                'features': [],
                'spec': 'design',
                'pop': '',
                'free': '',
                'link': '/courses/design/7-brend-v-digital-srede',
            },

            {
                'title': 'От custdev до&nbsp;повышения эффективности рекламы',
                'speaker': [
                    {
                        'name': 'Анастасия Романова',
                        'pic': '/static/main-page_v2/img/speakers/romanova.png',
                        'add': ''
                    },

                ],
                'description': 'Как изучать аудиторию и снижать стоимость привлечения клиентов\n',
                'summory': 'Директор по&nbsp;стратегическому развитию компании AiData.me расскажет, как успешно интегрировать готовые аудитории в&nbsp;маркетинговую стратегию, и&nbsp;детально остановится на&nbsp;нескольких инструментах исследования&nbsp;ЦА',
                'features': [],
                'spec': 'marketing',
                'pop': '',
                'free': 'true',
                'link': '/courses/marketing/12-ot-custdev-do-povysheniya-effektivnosti-reklamy',
            },

        ];

        let activeSpec = 'all';
        let isMobileDropdownOpen = false;

        // Функция для создания UI фильтра
        function createFilterUI() {
            specsFilter.innerHTML = '';

            // Создаем контейнер для кнопок (десктоп)
            const desktopButtons = document.createElement('div');
            desktopButtons.className = 'desktop-specs-buttons';

            Object.keys(specs).forEach(specKey => {
                const button = document.createElement('button');
                button.className = 'specs__item';
                button.dataset.spec = specKey;
                button.textContent = specs[specKey];

                if (specKey === activeSpec) {
                    button.classList.add('active');
                }

                button.addEventListener('click', function() {
                    filterCourses(this.dataset.spec);
                });

                desktopButtons.appendChild(button);
            });

            // Создаем выпадающий список для мобильных
            const mobileDropdown = document.createElement('div');
            mobileDropdown.className = 'mobile-specs-dropdown';

            // Создаем кнопку-триггер выпадающего списка
            const dropdownTrigger = document.createElement('div');
            dropdownTrigger.className = 'mobile-dropdown-trigger';
            dropdownTrigger.textContent = specs[activeSpec];

            // Создаем стрелку
            const dropdownArrow = document.createElement('span');
            dropdownArrow.className = 'mobile-dropdown-arrow';
            dropdownArrow.innerHTML = '▼';
            dropdownTrigger.appendChild(dropdownArrow);

            // Создаем выпадающее меню
            const dropdownMenu = document.createElement('div');
            dropdownMenu.className = 'mobile-dropdown-menu';

            Object.keys(specs).forEach(specKey => {
                const menuItem = document.createElement('div');
                menuItem.className = 'mobile-dropdown-item';
                menuItem.dataset.spec = specKey;
                menuItem.textContent = specs[specKey];

                if (specKey === activeSpec) {
                    menuItem.classList.add('active');
                }

                menuItem.addEventListener('click', function() {
                    filterCourses(this.dataset.spec);
                    closeMobileDropdown();
                });

                dropdownMenu.appendChild(menuItem);
            });

            // Обработчик открытия/закрытия выпадающего списка
            dropdownTrigger.addEventListener('click', function(e) {
                e.stopPropagation();
                toggleMobileDropdown();
            });

            // Закрытие выпадающего списка при клике вне его
            document.addEventListener('click', function() {
                closeMobileDropdown();
            });

            mobileDropdown.appendChild(dropdownTrigger);
            mobileDropdown.appendChild(dropdownMenu);

            // Добавляем оба элемента в контейнер
            specsFilter.appendChild(desktopButtons);
            specsFilter.appendChild(mobileDropdown);
        }

        // Функции для управления выпадающим списком
        function toggleMobileDropdown() {
            const dropdownMenu = document.querySelector('.mobile-dropdown-menu');
            if (dropdownMenu) {
                if (isMobileDropdownOpen) {
                    closeMobileDropdown();
                } else {
                    openMobileDropdown();
                }
            }
        }

        function openMobileDropdown() {
            const dropdownMenu = document.querySelector('.mobile-dropdown-menu');
            const dropdownArrow = document.querySelector('.mobile-dropdown-arrow');

            if (dropdownMenu && dropdownArrow) {
                dropdownMenu.style.display = 'flex';
                dropdownArrow.innerHTML = '▲';
                isMobileDropdownOpen = true;
            }
        }

        function closeMobileDropdown() {
            const dropdownMenu = document.querySelector('.mobile-dropdown-menu');
            const dropdownArrow = document.querySelector('.mobile-dropdown-arrow');

            if (dropdownMenu && dropdownArrow) {
                dropdownMenu.style.display = 'none';
                dropdownArrow.innerHTML = '▼';
                isMobileDropdownOpen = false;
            }
        }

        // Функция для обновления активного состояния фильтров
        function updateActiveFilter(spec) {
            // Обновляем кнопки десктопа
            const buttons = specsFilter.querySelectorAll('.specs__item');
            buttons.forEach(btn => {
                if (btn.dataset.spec === spec) {
                    btn.classList.add('active');
                } else {
                    btn.classList.remove('active');
                }
            });

            // Обновляем мобильный выпадающий список
            const dropdownTrigger = specsFilter.querySelector('.mobile-dropdown-trigger');
            const mobileItems = specsFilter.querySelectorAll('.mobile-dropdown-item');

            if (dropdownTrigger) {
                dropdownTrigger.textContent = specs[spec];

                // Восстанавливаем стрелку
                const arrow = document.createElement('span');
                arrow.className = 'mobile-dropdown-arrow';
                arrow.innerHTML = '▼';
                dropdownTrigger.appendChild(arrow);
            }

            mobileItems.forEach(item => {
                if (item.dataset.spec === spec) {
                    item.classList.add('active');
                } else {
                    item.classList.remove('active');
                }
            });
        }

        // Остальные функции
        function renderCourseCard(course) {
            let featuresHtml = '';
            if (course.features && course.features.length > 0) {
                featuresHtml = `
                <div class="course-features">
                    <ul>
                        ${course.features.map(feature => `<li>${feature}</li>`).join('')}
                    </ul>
                </div>
            `;
            }
            let summoryHtml = '';
            if (course.summory && course.summory !== '') {
                summoryHtml = `
                <div class="course-summory">
                        ${course.summory}
                </div>
            `;
            }

            let speakerHtml = '';
            if (course.speaker && course.speaker.length > 0) {
                speakerHtml = course.speaker.map(speaker => {
                    // Проверяем, определено ли значение speaker.smaller
                    const smallerClass = speaker.smaller ? ` ${speaker.smaller}` : '';

                    return `
                <div class="speaker">
                    <div class="speaker__img ${speaker.add || ''}">
                        <img src="${speaker.pic}" alt="${speaker.name}">
                    </div>
                    <div class="speaker__name ${smallerClass}">${speaker.name}</div>
                </div>
            `;
                }).join('');
            }

            return `
            <div class="course-card" data-spec="${course.spec}" 
                 data-pop="${course.pop}" data-free="${course.free}">
                <div class="course-card__left">
                    <div>
                        <div class="course-title">${course.title}</div>
                        ${speakerHtml}
                        <div class="course-body">
                            <p class="course-description">${course.description}</p>
                        </div>
                    </div>
                    <a href="${course.link}" class="btn__more" target="_blank">Подробнее</a>
                </div>
                <div class="course-card__right">
                    ${featuresHtml}
                    ${summoryHtml}
                    
                </div>
            </div>
        `;
        }

        function renderCourses(coursesToRender) {
            coursesContainer.innerHTML = '';

            if (coursesToRender.length === 0) {
                noCoursesElement.style.display = 'block';
                return;
            }

            noCoursesElement.style.display = 'none';

            coursesToRender.forEach((course, index) => {
                setTimeout(() => {
                    const wrapper = document.createElement('div');
                    wrapper.innerHTML = renderCourseCard(course).trim();
                    const cardElement = wrapper.firstChild;

                    if (cardElement) {
                        coursesContainer.appendChild(cardElement);
                        requestAnimationFrame(() => {
                            cardElement.classList.add('fade-in');
                        });
                    }
                }, index * 50);
            });
        }

        function filterCourses(spec) {
            activeSpec = spec;

            // Обновляем UI фильтра
            updateActiveFilter(spec);

            // Анимация исчезновения
            const currentCards = coursesContainer.querySelectorAll('.course-card');
            currentCards.forEach(card => {
                card.classList.remove('fade-in');
                card.classList.add('fade-out');
            });

            setTimeout(() => {
                let filteredCourses;

                if (spec === 'all') {
                    filteredCourses = courses;
                } else if (spec === 'pop') {
                    filteredCourses = courses.filter(course => course.pop === 'true');
                } else if (spec === 'free') {
                    filteredCourses = courses.filter(course => course.free === 'true');
                } else {
                    filteredCourses = courses.filter(course => {
                        if (Array.isArray(course.spec)) {
                            return course.spec.includes(spec);
                        } else {
                            return course.spec === spec; // старый формат
                        }
                    });
                }

                renderCourses(filteredCourses);

                // Обновляем URL
                const url = new URL(window.location);
                if (spec === 'all') {
                    url.searchParams.delete('spec');
                } else {
                    url.searchParams.set('spec', spec);
                }
                history.pushState({spec: spec}, '', url);

            }, 300);
        }

        // Обработчик кнопок "Назад/Вперед"
        window.addEventListener('popstate', function (event) {
            const urlParams = new URLSearchParams(window.location.search);
            const specFromUrl = urlParams.get('spec') || 'all';
            filterCourses(specFromUrl);
        });

        // Инициализация
        function initialisation() {
            createFilterUI();

            const urlParams = new URLSearchParams(window.location.search);
            const initialSpec = urlParams.get('spec') || 'all';

            filterCourses(initialSpec);
        }

        // Запускаем инициализацию
        initialisation();
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('in-viewport');
                observer.unobserve(entry.target);
            }
        });
    }, {threshold: 0.5});

    document.querySelectorAll('.ways__item').forEach(item => {
        observer.observe(item);
    });

 }

 document.addEventListener("DOMContentLoaded", init);
 // window.addEventListener("resize", init);